import React from "react";
import styles from "./css/AICoursePreviewModal.module.css";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { handleErrorMessage } from "../../../redux/actions/groups";

export default function AICoursePreviewModal({ open, loading, uploadedFiles, data, onClose }) {
  const history = useHistory();
  const token = localStorage.getItem("token");
  const dispatch = useDispatch();

  if (!open) return null;

  const handleCreateCourse = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}api/v1/suggestions/ai-course/`,
        { parsed_data: data },
        {
          headers: {
            Authorization: `Token ${token}`,
            "Content-Type": "application/json",
            Cookie: `token=${token}`
          }
        }
      );

      const courseId = res.data.data.course.id;
      history.push({
        pathname: `/course/content/${courseId}`,
        state: {
          isAiCourse: true,
          aiFiles: uploadedFiles
        }
      });
    } catch (err) {
      console.error(err);
      dispatch(handleErrorMessage("Error creating course. Please try again."));
    }
  };

  return (
    <div className={styles.backdrop} onClick={onClose}>
        <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        
        {/* Close */}
        <button className={styles.closeBtn} onClick={onClose}>×</button>

        {/* Header */}
        <div className={styles.header}>
            <div className={styles.headerIcon}>
            <img src="/Image/sparkle.svg" alt="AI" />
            </div>
            <h2>AI Generated Course Preview</h2>
            <p>Review the structure before creating your course</p>
        </div>

        {/* Body Card */}
        <div className={styles.body}>
            {loading ? (
            <>
                <div className={styles.skeletonTitle} />
                <div className={styles.skeletonPara} />
                <div className={styles.skeletonBlock} />
                <div className={styles.skeletonBlock} />
            </>
            ) : (
            <>
                <h3 className={styles.courseTitle}>{data?.name}</h3>
                <p className={styles.subtitle}>{data?.subtitle}</p>
                <p className={styles.description}>{data?.description}</p>

                <div className={styles.sectionList}>
                {data?.sections?.map((sec, i) => (
                    <details key={i} className={styles.accordion}>
                    <summary>{sec.title}</summary>
                    <p>{sec.description}</p>
                    </details>
                ))}
                </div>
            </>
            )}
        </div>

        {/* Footer */}
        {!loading && (
            <div className={styles.footer}>
            <button onClick={handleCreateCourse}>
                <img src="/Image/sparkle.svg" alt="" />
                Create Course
            </button>
            </div>
        )}

        </div>
    </div>
    );
}
